/** @prettier */
import classNames from 'classnames';
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BetslipContainer from '@xanadu/ui-shared/components/betslip/Betslip/BetslipContainer';
import ChildrenPropsContext from '@xanadu/ui-shared/contexts/ChildrenPropsContext';
import { useImprovedTranslation } from '@xanadu/ui-shared/hooks';
import { setCollapsed as setCollapsedAct } from '@xanadu/ui-shared/modules/betslip/actions';

import ArrowUpIcon from '../../../../images/icons/misc/Arrow-Up.svg';

import styles from './Betslip.module.scss';

const BetSlip = ({ unsubmittedOffers, openOffers, collapsed, setCollapsed }) => {
  const { customization: { Betslip: { dimension = 'standard' } = {} } = {} } =
    React.useContext(ChildrenPropsContext) || {};

  const matched = openOffers.filter((openOffer) => openOffer.status === 'matched');

  const unmatched = openOffers.filter((openOffer) => openOffer.status === 'open');

  const { t } = useImprovedTranslation();

  const mainClass = classNames({
    [styles.main]: true,
    [styles['main--collapsed']]: collapsed,
    [styles['main--expanded']]: !collapsed,
  });

  const dataClass = classNames({
    [styles.data]: true,
  });

  const mainContainer = classNames({
    [styles.mainContainer]: true,
    [styles[`mainContainer--${dimension}`]]: true,
    [styles['mainContainer--collapsed']]: collapsed,
    [styles['mainContainer--expanded']]: !collapsed,
  });

  const iconContainerClass = classNames({
    [styles.iconContainer]: true,
    [styles['iconContainer--collapsed']]: collapsed,
    [styles['iconContainer--expanded']]: !collapsed,
    [styles[`iconContainer--expanded--${dimension}`]]: !collapsed,
  });

  const betslipContainerClass = classNames({
    [styles.betslipContainer]: true,
  });

  useEffect(() => {
    if (unsubmittedOffers.size > 0) {
      setCollapsed(false);
    }
  }, [unsubmittedOffers]);

  return (
    <div className={mainContainer}>
      <button
        className={iconContainerClass}
        data-hook="betslip-toggle-open-close-btn"
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        <ArrowUpIcon />
      </button>
      <div
        role="button"
        className={mainClass}
        data-hook="collapsed-betslip-summary"
        onClick={() => {
          setCollapsed(!collapsed);
        }}
      >
        <div className={dataClass}>
          <div>{t('Your Betslip')}</div>
          <div className={styles.betsList}>
            <div>{`${unsubmittedOffers.size} ${t('Pending')}`}</div>
            <div>{`${matched.size} ${t('Matched')}`}</div>
            <div>{`${unmatched.size} ${t('Unmatched')}`}</div>
          </div>
        </div>
      </div>
      {!collapsed && (
        <div className={betslipContainerClass}>
          <BetslipContainer />
        </div>
      )}
    </div>
  );
};

BetSlip.propTypes = {
  unsubmittedOffers: PropTypes.instanceOf(List).isRequired,
  openOffers: PropTypes.instanceOf(List).isRequired,
  collapsed: PropTypes.bool.isRequired,
  setCollapsed: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  setCollapsed: setCollapsedAct,
};

function mapStateToProps(state) {
  return {
    unsubmittedOffers: state.get('unsubmittedOffers'),
    openOffers: state.getIn(['openOffers', 'data']),
    collapsed: state.getIn(['betslip', 'collapsed']),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BetSlip));
